import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";

import Footer from "../ones/Footer";
import HomeSlider from "../ones/HomeSlider";
import HomeBanner1 from "../ones/HomeBanner1";
import IntroPara from "../ones/IntroPara";
import AboutCompany from "../ones/AboutCompany";
import Impact from "../ones/Impact";
import Programs from "../ones/Programs";
import CustomersHighlight from "../ones/CustomersHighlight";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	if(ready) {
		return (
			<>
				<HomeSlider/>
				<AboutCompany/>
				<IntroPara/>
				<CustomersHighlight/>
				<Impact/>
				<HomeBanner1/>
				<Programs/>
				<Footer/>
			</>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}